define.alias("checkout/components/alert-banner", "settings/components/alert-banner");